import { Switch } from '@thanx/uikit/switch'
import { TextArea } from '@thanx/uikit/textarea'
import { withFormsy } from 'formsy-react'
import { Button } from 'react-bootstrap'

import { buildTranslate } from 'locales'
import { splitByComma } from 'scenes/RedeemManager/helpers'
import ModifierPopover from './OnlineRedemptionCard/ModifierPopover'

type ModifierOrProductInputProps = {
  name: string
  label: string
  secondaryText?: string
  tertiaryText?: string
  value?: string[]
  className?: string
  disabled?: boolean
  setValue: (value: string[]) => void
  toggleVisibility?: (visible: boolean) => void
  shouldDisplayModifierPopover?: boolean
}

const t = buildTranslate('redeem_manager.modifier_select')

export const ModifierOrProductInput = (props: ModifierOrProductInputProps) => {
  const {
    name,
    label,
    secondaryText,
    tertiaryText,
    value: selectedIds = [],
    className = '',
    disabled = false,
    setValue,
    toggleVisibility,
    shouldDisplayModifierPopover = false,
  } = props

  const toggleInputVisibility = () => {
    toggleVisibility?.(false)
    setValue([])
  }

  const handleChange = (newValue: string) => {
    if (!newValue) return setValue([])
    setValue(splitByComma(newValue))
  }

  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <div className="d-flex flex-row">
          <label id={name} className="body-text-4 bold mb-0">
            {label}
          </label>
          <Switch condition={shouldDisplayModifierPopover}>
            <ModifierPopover />
          </Switch>
        </div>
        <Switch condition={Boolean(toggleVisibility)}>
          <Button
            bsStyle="link"
            type="button"
            onClick={toggleInputVisibility}
            className="p-0 m-0"
          >
            {t('wrapper.hide')}
          </Button>
        </Switch>
      </div>

      <Switch condition={Boolean(secondaryText)}>
        <p className="mt-0 body-text-4 grey-70">{secondaryText}</p>
      </Switch>

      <Switch condition={Boolean(tertiaryText)}>
        <p className="mt-0 body-text-4 grey-70">{tertiaryText}</p>
      </Switch>

      <TextArea
        className={className}
        aria-labelledby={name}
        name={name}
        value={selectedIds}
        disabled={disabled}
        onChange={newValue => handleChange(newValue)}
      />
    </div>
  )
}

export default withFormsy(ModifierOrProductInput)
